module.exports = __webpack_public_path__ + "static/img/breathe_banner_mobile.ab0daa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/breathe_banner_mobile.png
// module id = vPGz
// module chunks = 1